import './bootstrap'
import './sprite'
import * as modules from './modules'

import.meta.glob([
    '../images/**'
])

// Some functionalities should be loaded immediately instead of on init.
modules.recaptcha()
modules.tinySliders()
modules.lazyLoad()

document.addEventListener('DOMContentLoaded', () => {
    // Order matters!
    modules.images()
    modules.blogDetailHeaders()
    modules.navigation()
    modules.accordion()
    modules.video()
    modules.tabs()
    modules.dropdown()
    modules.scrollTo()
    modules.form()
    modules.search()
    modules.storeLocations()
    modules.notificationBar()
    modules.compare.init()
    modules.carousel()
    modules.marketSiteSwitch()
    modules.listingFilters()
    modules.blogFilters()
    modules.product()
    modules.downloadSelect()
    modules.newsletterPopup()
    modules.cordialNewsletter()
    modules.marketSiteSelectorPopup()
    modules.nitro()
    modules.nitroForms()
    modules.animatedVideo()
    modules.tagManagerEvents()
    modules.verticalTimeline()
    modules.verticalTimelineSmall()
    modules.wizard()
    modules.charts()
})
